import { createAction } from '@reduxjs/toolkit';

export const changeGlobalParameter = createAction('project/changeGlobalParameter');
